import { Component, OnInit } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { NotificationService } from '../../services/notification.service';
import { catchError, EMPTY, take, tap } from 'rxjs';
import { UserNotification } from '../models/user-notification.model';
import { NotificationGroup } from '../models/notification-group.model';
import moment from 'moment';
import { RoleGuardService } from '../../role-guard.service';
import { AuthService } from '../../core/auth-service';

@Component({
  selector: 'app-notification-centre',
  templateUrl: './notification-centre.component.html',
  styleUrl: './notification-centre.component.scss'
})
export class NotificationCentreComponent implements OnInit {

  loading: boolean;
  unreadCount: number;
  unread: Array<NotificationGroup>;
  read: Array<NotificationGroup>;
  notifications: Array<UserNotification>;
  inTheGame: boolean;

  constructor(private messageService: MessageService,
    private notificationService: NotificationService,
    private roleGuardService: RoleGuardService) { }
  
  ngOnInit(): void {
    this.loading = true;
    this.inTheGame = this.roleGuardService.hasRole(AuthService.viewTrophies);
    this.unread = new Array<NotificationGroup>();
    this.read = new Array<NotificationGroup>();
    this.messageService.getNotifications$(true).pipe(
      tap(result => {
        this.notifications = result.filter(x => this.isActive(x));
        this.groupNotifications();
        this.loading = false;
      }),
      catchError((err) => {
        this.notificationService.dangerToast('Unable to view notifications', err);
        return EMPTY;
      })
    ).subscribe();
  }

  private isActive(notification: UserNotification): boolean {
    // Ignore pog notifications if they don't have the associated role
    if (notification.notificationType === 2 && !this.inTheGame) {
      return false;
    }
    return true;
  }

  private groupNotifications(): void {
    this.unreadCount = 0;
    this.unread = new Array<NotificationGroup>();
    this.read = new Array<NotificationGroup>();
    this.notifications.forEach(notification => {
      if (notification.isRead) {
        this.groupNotification(this.read, notification);
      } else {
        this.unreadCount += 1;
        this.groupNotification(this.unread, notification);
      }
    });
  }

  private groupNotification(groups: Array<NotificationGroup>, notification: UserNotification) {
    const notificationDay = moment(notification.dateAdded).format('dddd Do of MMMM');

    let group = groups.find(x => x.notificationDay === notificationDay);
    if (group) {
      group.notifications.push(notification);
    } else {
      group = new NotificationGroup();
      group.notificationDay = notificationDay;
      group.notifications.push(notification);
      groups.push(group);
    }
  }

  dealWithIt(notification: UserNotification): void {
    this.messageService.readNotification$(notification.notificationId).pipe(
      tap(() => {
      }),
      catchError(err => {
        this.notificationService.dangerToast(
          'Failed to read notification',
          err
        );
        return EMPTY;
      }),
      take(1)
    ).subscribe();
    notification.isRead = true;
    this.groupNotifications();
    this.messageService.navigateToNotification(notification);
  }
}
